import Vue from 'vue'
import Router from 'vue-router'
import overview from './overview'
import system from './system'
Vue.use(Router)

export default new Router({
  routes: [
      {
       path: '/',
       name: 'index',
       component: () => import('@/views/index'),
       redirect: {name:'dept'},
       children:[...overview,...system]
      },
      {
        path: '/login',//登录
        name: 'login',
        component: () => import('@/views/login'),
      },
      {
        path: '/multiHouseholdLogin',//多住户用户注册
        name: 'multiHouseholdLogin',
        component: () => import('@/views/multiHouseholdLogin'),
      },
      {
        path: '/register',//用户注册
        name: 'register',
        component: () => import('@/views/register'),
      },
      {
        path: '/forgetPasswod',//重置密码
        name: 'forgetPasswod',
        component: () => import('@/views/forgetPasswod'),
      },
      {
        path: '/userChange',//用户选择跳转哪个版本
        name: 'userChange',
        component: () => import('@/views/userChange'),
      },
      {
        path: '/geneinfoOverview',
        name: 'geneinfoOverview',
        component: () => import('@/views/geneinfoOverview')
      },
      {
        path: '/DemoVersion',//Demo版本的界面
        name: 'DemoVersion',
        component: () => import('@/views/DemoVersion')
      },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js